module.exports = "/React/dist/9c42760cc453f1346f27ecb64a8dce1d.png";